import React from "react";
import { useParams, useHistory } from "react-router-dom";
import config from "../../config/config";
import navigationsLinks from "../../constants/navigation_links";
import Header from "../../components/template/website/Header";
import Footer from "../../components/template/estimate/Footer";
import { useSelector } from "react-redux";
export default function Confirmation() {
  const userInfo = useSelector((state) => state.userInfo);
  const history = useHistory();
  const params = useParams();
  const JSX = (
    <>
      <Header />
      <main class="container">
        <section class="confirmation-container mt-4">
          <div class="row align-items-center">
            <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
              <div class="img-container text-center">
                <img
                  src={`${config.customerPortal}assets/images/estimate/thank-you.svg`}
                  alt="thank-you"
                />
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8">
              <div class="content-container">
                <p>
                  <b>{userInfo.customerName}</b>, Your <span className="text-capitalize">{params.serviceType}  </span>inquire ID{" "}
                  <b> {params.estimateId} </b> has been received successfully.
                </p>
                <p>
                  Our team is currently reviewing your request, and we will get back to you as soon as possible with the information you need in 24 hours.
                </p>
                <p>
                Thank you again for contacting us.
                </p>
              </div>
            </div>
          </div>
          <div class="whats-next-container">
            <div class="text-center mt-1 mb-5">
              <button
                onClick={() => history.push(navigationsLinks.dashboard_page)}
                class="btn btn-sm px-3"
              >
                Visit Dashboard
              </button>
            </div>
            <div class="question-img d-flex align-items-center justify-content-center">
              <div>
                <h1 class="text-active">What Next</h1>
              </div>
              <div>
                <img
                  src={`${config.customerPortal}assets/images/estimate/question.png`}
                  class="img-fluid"
                  alt="question"
                />
              </div>
            </div>

            <div class="flowchart-container">
              <div class="row align-items-center justify-content-center">
                <div class="col-md-4">
                  <div class="flow-img-container">
                    <img
                      src={`${config.customerPortal}assets/images/icons_new/circle.png`}
                      class="img-fluid circle"
                      alt="circle"
                    />
                    <img
                      src={`${config.customerPortal}assets/images/estimate/education.png`}
                      class="img-fluid icon"
                      alt="education"
                    />
                    <img
                      src={`${config.customerPortal}assets/images/icons_new/up.png`}
                      class="img-fluid up line"
                      alt="up"
                    />
                  </div>
                  <div class="text-center mt-3">
                    <h3 class="text-uppercase">Compare</h3>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="flow-img-container">
                    <img
                      src={`${config.customerPortal}assets/images/icons_new/circle.png`}
                      class="img-fluid circle"
                      alt="circle"
                    />
                    <img
                      src={`${config.customerPortal}assets/images/estimate/monitor.png`}
                      class="img-fluid icon"
                      alt="monitor"
                    />
                    <img
                      src={`${config.customerPortal}assets/images/icons_new/down.png`}
                      class="img-fluid down line"
                      alt="down"
                    />
                  </div>
                  <div class="text-center mt-3">
                    <h3 class="text-uppercase">Book</h3>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="flow-img-container">
                    <img
                      src={`${config.customerPortal}assets/images/icons_new/circle.png`}
                      class="img-fluid circle"
                      alt="circle"
                    />
                    <img
                      src={`${config.customerPortal}assets/images/estimate/move.png`}
                      class="img-fluid icon"
                      alt="move"
                    />
                  </div>
                  <div class="text-center mt-3">
                    <h3 class="text-uppercase">Move</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
  return JSX;
}
